import { COLLECTION_ORDER_STATUSES } from 'models/order';

import { orderStatusesFromMapping } from '../utils/stats';
import type {
  NormalizedOrderStats,
  NormalizedOrderStatus,
  OrderStatsBackend
} from '../utils/types';

export function adaptOrderResponse(
  statsResponse: OrderStatsBackend | null | undefined
): NormalizedOrderStats {
  const totalCount = statsResponse?.count ?? 0;
  const statuses: NormalizedOrderStatus[] = statsResponse?.data ?? [];
  const statusItems = orderStatusesFromMapping(
    COLLECTION_ORDER_STATUSES,
    statuses
  );
  return { totalCount, statuses, statusItems };
}
